export default function CompletedDocumentAttachmentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  editDocumentAttachmentDialog,
  ssDialogService,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Completed Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditAttachment = _handleEditAttachment;
  vm.handleDeleteAttachment = _handleDeleteAttachment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditAttachment($event) {
    ssDialogService.dialogs.pm.editDocumentAttachmentDialog = ssDialogService.alert(
      editDocumentAttachmentDialog.getOptions($event, {
        document: {
          policyDocumentId: vm.policyDocumentId,
        },
        attachment: vm.attachment,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  function _handleDeleteAttachment($event) {
    ssDialogService.dialogs.pm.deleteCompletedDocumentAttachmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Attached Document?',
        message: `Are you sure you want to delete document "${vm.attachment.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pm.deleteCompletedDocumentAttachmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return pmDataService.deleteDocumentAttachment(vm.attachment.policyDocumentAttachmentId)
      .then(() => {
        alerts.success('The document has been deleted successfully.');
        $rootScope.$broadcast('refreshPMDocumentAttachments',
          { policyDocumentId: vm.attachment.policyDocumentId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.deleteCompletedDocumentAttachmentConfirmDialog);
  }
}

CompletedDocumentAttachmentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'pmDataService',
  'pmSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'editDocumentAttachmentDialog',
  'ssDialogService'
];
